export default {"src":"/_next/static/media/ico_prev.ac757ff4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};